import { render, staticRenderFns } from "./test-template.vue?vue&type=template&id=f0ef8ad0&scoped=true&"
import script from "./test-template.vue?vue&type=script&lang=ts&"
export * from "./test-template.vue?vue&type=script&lang=ts&"
import style0 from "./test-template.vue?vue&type=style&index=0&id=f0ef8ad0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ef8ad0",
  null
  
)

export default component.exports